import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e1e1576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { href: "https://billing.stripe.com/p/login/dR68wO9sjaXebvy5kk" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading user data ... ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { href: "https://billing.stripe.com/p/login/dR68wO9sjaXebvy5kk" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stripe_pricing_table = _resolveComponent("stripe-pricing-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      ($setup.tier === 'FREE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!$setup.userId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("accountView.loadingUserData")), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_stripe_pricing_table, {
                    "pricing-table-id": "prctbl_1PSyYjRqHJMvBuOgrVsrjOI3",
                    "publishable-key": "pk_live_51PBuT4RqHJMvBuOgNROhDOstXpPJexP2ruBCwDhTLLQfcTfskrCgMDVtuDrEd8VIW3Kd2L2uKRUOSWBsvafGAue600oRzZqXY9",
                    "client-reference-id": $setup.userId
                  }, null, 8, ["client-reference-id"]),
                  _createElementVNode("a", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      class: "mt-3 my-btn",
                      color: "#4B2D9F"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("accountView.manageSubscriptionButton")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card, {
        variant: "elevated",
        class: "my-card mt-3 mb-3 area-1",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("accountView.myAccountTitle")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("accountView.nameLabel")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.firstName + " " + $setup.lastName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("accountView.subscriptionLabel")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.translatedTier), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("accountView.activeStatus")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.paymentExpirationDate
                  ? $setup.formatDate($setup.paymentExpirationDate)
                  : _ctx.$t("accountView.noActiveSubscription")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/terms&conditions" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "mt-4",
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("accountView.termsConditionsButton")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      ($setup.tier === 'PAID')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!$setup.userId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_stripe_pricing_table, {
                    "pricing-table-id": "prctbl_1PSyYjRqHJMvBuOgrVsrjOI3",
                    "publishable-key": "pk_live_51PBuT4RqHJMvBuOgNROhDOstXpPJexP2ruBCwDhTLLQfcTfskrCgMDVtuDrEd8VIW3Kd2L2uKRUOSWBsvafGAue600oRzZqXY9",
                    "client-reference-id": $setup.userId
                  }, null, 8, ["client-reference-id"]),
                  _createElementVNode("a", _hoisted_11, [
                    _createVNode(_component_v_btn, {
                      class: "mt-3 my-btn",
                      color: "#4B2D9F"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("accountView.manageSubscription")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}